/** Mirrors backend `Perm` string constants for type-safe checks with `useHasPermission`. */

export const Perm = {
  PROJECT_READ: "project.read",
  PROJECT_CREATE: "project.create",
  PROJECT_UPDATE: "project.update",
  PROJECT_DELETE: "project.delete",
  CLIENT_READ: "client.read",
  CLIENT_DELETE: "client.delete",
  ACCOUNT_SETTINGS_UPDATE: "account.settings.update",
  ACCOUNT_DELETE: "account.delete",
  MEMBERSHIP_READ: "membership.read",
  MEMBERSHIP_INVITE: "membership.invite",
  MEMBERSHIP_UPDATE: "membership.update",
  BILLING_READ: "billing.read",
  BILLING_MANAGE: "billing.manage",
} as const

/**
 * Roles an invite or membership edit may assign — `owner` is deliberately excluded (ownership
 * moves only via transfer). Mirrors backend `ASSIGNABLE_ROLE_KEYS` in `app/core/permissions.py`.
 */
export const ASSIGNABLE_ROLE_KEYS = ["viewer", "editor", "admin"] as const

export type AssignableRoleKey = (typeof ASSIGNABLE_ROLE_KEYS)[number]
